import { MessageCircle } from 'lucide-react';
import { EmptyState, ErrorState, Skeleton } from '@/shared/ui';
import { useComments } from '../api/useComments';
import { CommentItem } from './CommentItem';

export function CommentList({ articleId }: { articleId: string }) {
  const { data, isPending, isError, refetch } = useComments(articleId);

  if (isPending) {
    return (
      <div className="space-y-4">
        {Array.from({ length: 2 }).map((_, i) => (
          <Skeleton key={i} className="h-16 rounded-2xl" />
        ))}
      </div>
    );
  }

  if (isError) {
    return <ErrorState title="Couldn’t load comments" onRetry={() => void refetch()} />;
  }

  if (data.length === 0) {
    return (
      <EmptyState
        icon={MessageCircle}
        title="No comments yet"
        message="Be the first to share your thoughts."
      />
    );
  }

  return (
    <div className="space-y-6">
      {data.map((comment) => (
        <CommentItem key={comment.id} articleId={articleId} comment={comment} />
      ))}
    </div>
  );
}
